/**
 * Sorgente unica delle lingue del sito — aggiungere una lingua futura
 * significa aggiungere una riga qui, nulla da toccare nel routing/admin.
 * Lingua di default = niente prefisso nell'URL (/storia), le altre sono
 * prefissate (/en/storia) — pattern standard per SEO multilingua.
 */
export const LOCALES = [
  { code: 'it', label: 'Italiano', flag: '🇮🇹', ogLocale: 'it_IT' },
  { code: 'en', label: 'English', flag: '🇬🇧', ogLocale: 'en_US' },
];

export const DEFAULT_LOCALE = 'it';
export const LOCALE_CODES = LOCALES.map((l) => l.code);

/** slug canonico (es. '/', '/storia') → path per la lingua richiesta. */
export function localizedPath(slug, localeCode) {
  if (localeCode === DEFAULT_LOCALE) return slug;
  return slug === '/' ? `/${localeCode}` : `/${localeCode}${slug}`;
}

/** pathname corrente → { locale, slug } scomponendo l'eventuale prefisso lingua. */
export function parseLocalizedPath(pathname) {
  const seg = pathname.split('/')[1];
  if (seg && LOCALE_CODES.includes(seg) && seg !== DEFAULT_LOCALE) {
    const rest = pathname.slice(seg.length + 1);
    return { locale: seg, slug: rest === '' ? '/' : rest };
  }
  return { locale: DEFAULT_LOCALE, slug: pathname || '/' };
}
